import { useMemo } from 'react';
import useSms from 'hooks/queries/useSms';
import useContactColumns from 'hooks/queries/useContactColumns';
import { getMergeTags } from 'utils';

const useSmsData = ({ id, enabled }: { id: string | null; enabled?: boolean }) => {
    // Fetch SMS and contact data
    const { data: smsData, isSuccess, isLoading, error } = useSms(id, {
        enabled: id !== 'default' && id !== null && enabled,
    });

    const { data: contactColumns, isSuccess: isContactColumnsSuccess } = useContactColumns();

    // Derived state
    const isSmsContent = useMemo(() => isSuccess && !!smsData?.id, [isSuccess, smsData]);

    const mergeTags = useMemo(() => {
        if (isContactColumnsSuccess) {
            return getMergeTags(contactColumns);
        }
        return [];
    }, [contactColumns, isContactColumnsSuccess]);

    const orderedMergeTags = useMemo(() => mergeTags?.sort((a, b) => a.value.localeCompare(b.value)), [mergeTags]);

    return {
        error,
        mergeTags: orderedMergeTags,
        smsData,
        isLoading,
        isSmsContent,
    };
};

export default useSmsData;
